import ContactProfileImage from '@app/components/ContactProfileImage'
import { NotificationSourceType } from '@app/models/enums'
import { INotification } from '@app/models/Notification'
import { siteRoutingActionCreators } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import { notificationItemActionCreators } from '@app/store/modules/systemNotifications'
import { bindFunctions } from '@app/utils/class'
import { formatDateFromNow } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import './SystemNotificationItem.scss'

export interface ISystemNotificationItemProps {
  item: INotification
  style?: React.CSSProperties
}

type NotificationItemProps = ISystemNotificationItemProps &
  RouteComponentProps<{}> &
  typeof siteRoutingActionCreators &
  typeof notificationItemActionCreators

export class SystemNotificationItem extends React.PureComponent<NotificationItemProps> {
  constructor(props: NotificationItemProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    const itemClasses = classNames('notification-item', {
      unseen: !this.props.item.seen,
    })

    return (
      <div
        className={itemClasses}
        onClick={this._onItemClick}
        style={this.props.style}
      >
        <div className='mr-2'>
          <ContactProfileImage contact={this.props.item.creatorId} size={35} />
        </div>
        <div className='flex-grow-1'>
          <div>{this.props.item.notificationText}</div>
          <div className='small'>
            {formatDateFromNow(this.props.item.dateCreated)}
          </div>
        </div>
        {!this.props.item.seen && (
          <div className='ml-2'>
            <a
              className='mark-seen'
              onClick={this._onMarkSeen}
              title='Mark as read'
            >
              <FontAwesomeIcon icon={['fas', 'circle']} size='lg' fixedWidth />
            </a>
          </div>
        )}
      </div>
    )
  }

  private _onItemClick() {
    this.props.markSeen(this.props.item.context, this.props.item.id)

    switch (this.props.item.type) {
      case NotificationSourceType.Assignment:
        this.props.history.push(`/assignment/${this.props.item.sourceId}`)
        break

      case NotificationSourceType.Message:
        this.props.history.push(`/message/${this.props.item.sourceId}`)
        break

      case NotificationSourceType.DueDiligenceItem:
        this.props.getSiteRouting(this.props.item.sourceId)
        break

      case NotificationSourceType.SiteSuggestion:
        this.props.history.push(
          `/development/clients/${this.props.item.sourceId}/sites`,
        )
        break

      case NotificationSourceType.ChatMention:
        // Force full page refresh to chat with specific channel
        window.location.href = `/chat?channel=${this.props.item.sourceId}`
        break

      default:
        this.props.history.push(`/feed/${this.props.item.sourceId}`)
        break
    }
  }

  private _onMarkSeen(event: React.MouseEvent<HTMLAnchorElement>) {
    event.stopPropagation()
    this.props.markSeen(this.props.item.context, this.props.item.id)
  }
}
